var HtmlComponent_default = {
  "htmlComponent": "_08XfU",
  "htmlComponent_placeholder": "Sc-76"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
